import { useMediaQuery } from 'react-responsive';
import { breakpointReverseSm } from '@fiverr-private/sass/helpers';
import { useIsClient } from '@fiverr-private/hooks';
import { useUserAgentContext } from '../../components/UserAgentContext';

export const useIsMobile = () => {
    const userAgent = useUserAgentContext();
    const isMobileSize = useMediaQuery({
        query: `(max-width: ${breakpointReverseSm}px)`,
    });
    const isClient = useIsClient();

    if (isClient) {
        return userAgent.isMobile || isMobileSize;
    }
    return userAgent.isMobile;
};
